import { Card, CardActionArea, CardContent, CardMedia } from "@mui/material";
import React, { memo } from "react";
import Slider from "react-slick";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { Video_baseUrl } from "../../services/AzureStorage";
import "./GameAuditSlickSlider.css";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import placeholder from "../../images/video-placeholder.png";

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 300,
    margin: "auto",
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)",
    },
  },
  media: {
    objectFit: "fill",
  },
  content: {
    textAlign: "left",
    padding: theme.spacing.unit * 3,
  },
  divider: {
    margin: `${theme.spacing.unit * 3}px 0`,
  },
  heading: {
    fontWeight: "bold",
  },
  subheading: {
    lineHeight: 1.8,
  },
  avatar: {
    display: "inline-block",
    border: "2px solid white",
    "&:not(:first-of-type)": {
      marginLeft: -theme.spacing.unit,
    },
  },
  auditPaper: {
    width: "190px !important",
    margin: "auto",
    "&:hover": {
      // boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)",
    },
  },
}));
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        background: "#fff",
        borderRadius: "50px 0 0 50px",
        border: "1px solid #e2e2e2",
        height: "45px",
        width: "20px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        background: "#fff",
        borderRadius: "0 50px 50px 0",
        border: "1px solid #e2e2e2",
        height: "45px",
        width: "20px",
      }}
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 7,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#2129BC",
    color: "#2129BC",
    boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "3px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const StyledSelectedVideoBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#FF0000",
    color: "#FF0000",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const AuditVideoListSlider = ({
  activeVideo,
  auditVideoList,
  handleVideoSelect,
  loading,
}) => {
  const classes = useStyles();

  return (
    <Box mx={1}>
      {loading && (
        <Box className="spinner">
          <Box className="bounce1"></Box>
          <Box className="bounce2"></Box>
          <Box className="bounce3"></Box>
        </Box>
      )}

      <Slider {...settings}>
        {auditVideoList.map((audit, index) => (
          <Card
            sx={{
              cursor: "pointer",
              height: "115px",
              borderRadius: "8px",
              backgroundColor:
                activeVideo.videoUrl === audit.videoUrl ? "#e6eeff" : "",
              border:
                activeVideo.videoUrl === audit.videoUrl
                  ? "2px solid #1d428a"
                  : "",
            }}
            className={classes.auditPaper}
            onClick={() => handleVideoSelect(audit)}
            key={index}
          >
            <CardActionArea>
              <Box style={{ position: "relative" }}>
                <CardMedia
                  component="img"
                  height="60"
                  image={`${Video_baseUrl(audit.thumbnail)}`}
                  alt={audit.drillType}
                  className={classes.media}
                  onError={(e) => {
                    e.target.src = placeholder; // Set the URL of your default image
                  }}
                />

                <Box
                  style={{
                    position: "absolute",
                    color: "white",
                    top: 10,
                    left: "15%",
                    transform: "translateX(-50%)",
                  }}
                >
                  {activeVideo.videoUrl === audit.videoUrl ? (
                    <BootstrapTooltip title="Streaming">
                      <StyledSelectedVideoBadge
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        variant="dot"
                      ></StyledSelectedVideoBadge>
                    </BootstrapTooltip>
                  ) : index === 0 ? (
                    <BootstrapTooltip title="Start" arrow>
                      <StyledBadge
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        variant="dot"
                      ></StyledBadge>
                    </BootstrapTooltip>
                  ) : null}
                </Box>
              </Box>
              <CardContent sx={{ padding: "8px" }}>
                <Box sx={{ padding: "0px 0px 5px 10px" }}>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      width: "100%",
                      whiteSpace: "nowrap",
                      fontSize: "0.85rem",
                      fontWeight: "bold",
                    }}
                  >
                    {audit.playerName}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontSize="0.75rem"
                  >
                    {audit.drillType}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Slider>
    </Box>
  );
};

export default memo(AuditVideoListSlider);
